import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import {useEffect, useState} from "react";
import {storePatientService} from "../../../services/patientService";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import {listDoctorsService} from "../../../services/doctorService";

const useNewPatient = () => {

    const {formId, formField} = form;

    const [isLoading, setIsLoading] = useState(true);

    const [doctors, setDoctors] = useState([]);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {

        const init = async () => {
            setIsLoading(true);
            await loadDoctors();
            setIsLoading(false);
        };

        init();

    }, []);

    const loadDoctors = async () => {

        try {

            const response = await listDoctorsService({
                sort: 'name',
                direction: 'asc',
                active: true
            });

            if(response.data.data.length > 0)
                setDoctors([{id: -1, label: "Selecciona una opción"}, ...response.data.data.map(doctor => ({id: doctor.id, label: capitalizeFirstLetter(doctor.name)}))]);
            else
                setDoctors([{id: -1, label: "Selecciona una opción"}]);

        } catch (error) {

            setSnackbarConfig({
                message: "Ocurrió un error cargando los doctores",
                icon: 'cancel',
                title: 'Doctores',
                color: 'warning'
            });

            setShow(true);

        }
    };
    const handleSubmit = async (values, actions) => {

        try {

            // Enviar datos a API
            await storePatientService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: 'Paciente registrado exitosamente',
                icon: 'notifications',
                title: 'Doctores',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Pacientes',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        doctors,
        validations,
        formId,
        formField,
        isLoading,
        show,
        initialValues,
        snackbarConfig,
        handleSubmit,
        toggleSnackbar
    };
};

export default useNewPatient;
